import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { Drawer } from "antd";
import SidebarRender from "../components/Sidebar";
import { IProductInfo, ISku } from "../index";


export interface ComponentProps {
    className?: string;
    productInfo: IProductInfo | null;
    currentSkuInfo: ISku | null;
    onSkuChange: (skuInfo: ISku | null) => void;
};

const PolicyRender: FC<ComponentProps> = ({ className = "", productInfo, currentSkuInfo, onSkuChange }) => {
    const { t } = useTranslation();
    const [dialogVisible, setDialogVisible] = useState(false);

    const onAddCartingButtonClick = () => {
        setDialogVisible(true);
    };

    const onClose = () => {
        setDialogVisible(false);
    }

    if (!productInfo) {
        return null;
    }

    return (
        <>
            <Drawer
                title={t('common.select_placeholder')}
                placement="bottom"
                onClose={onClose}
                open={dialogVisible}
                height="auto"
                bodyStyle={{ padding: "12px", maxHeight: "75vh", overflowY: "auto" }}
            >
                <SidebarRender productInfo={productInfo} onChange={onSkuChange}></SidebarRender>
            </Drawer>
            <div className="fixed inset-x-0 bottom-0 z-20 block border-t border-neutral-200 bg-white py-3 text-neutral-900 lg:hidden" style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}>
                <div className="container flex items-center justify-between gap-3">
                    <div className="flex min-w-0 flex-wrap items-baseline gap-x-1 font-semibold">
                        <span className="text-sm sm:text-base">{t('cart.total_amount')}：</span>
                        <span className="text-lg sm:text-xl">{`HKD $${currentSkuInfo?.totalPrice || 0}`}</span>
                    </div>
                    <ButtonPrimary className="shrink-0" sizeClass="px-3 py-2 sm:px-4" onClick={onAddCartingButtonClick}>{t('cart.add_to_cart')}</ButtonPrimary>
                </div>
            </div>
        </>

    );
};

export default PolicyRender;